export default __webpack_public_path__ + "static/media/ch-pert.d4073d55.png";